import script from "./Krediflow-External-Pdf.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-External-Pdf.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__